import { render, staticRenderFns } from "./TopOfCampaigns.vue?vue&type=template&id=6afb439d&"
import script from "./TopOfCampaigns.vue?vue&type=script&lang=ts&"
export * from "./TopOfCampaigns.vue?vue&type=script&lang=ts&"
import style0 from "./TopOfCampaigns.vue?vue&type=style&index=0&id=6afb439d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports